// extracted by mini-css-extract-plugin
export default {"container":"Certificates_container__IaDBv","tile":"Certificates_tile__ZUmlw"};